import _someInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/some";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import React, { Fragment } from 'react';
import { map } from 'lodash';
import { Heading as RexLabsHeading, Body as RexLabsBody } from '@rexlabs/text';
import { Grid, Column } from '@rexlabs/grid';
export function FormRendererTabContent(_ref) {
  var gutter = _ref.gutter,
      groups = _ref.groups,
      fieldGroups = _ref.fieldGroups,
      _ref$Heading = _ref.Heading,
      Heading = _ref$Heading === void 0 ? function (props) {
    return /*#__PURE__*/React.createElement(RexLabsHeading, _extends({
      level: 3
    }, props));
  } : _ref$Heading,
      _ref$Description = _ref.Description,
      Description = _ref$Description === void 0 ? function (props) {
    return /*#__PURE__*/React.createElement(RexLabsBody, props);
  } : _ref$Description;
  return /*#__PURE__*/React.createElement(Grid, {
    gutter: gutter
  }, map(fieldGroups, function (group, key) {
    var _groups$find;

    var groupLabel = (_groups$find = _findInstanceProperty(groups).call(groups, function (group) {
      return group.name === key;
    })) === null || _groups$find === void 0 ? void 0 : _groups$find.label;

    var hasVisibleFields = _someInstanceProperty(group).call(group, function (field) {
      var _field$fieldProps;

      return !(field === null || field === void 0 ? void 0 : (_field$fieldProps = field.fieldProps) === null || _field$fieldProps === void 0 ? void 0 : _field$fieldProps.hidden);
    });

    return /*#__PURE__*/React.createElement(Fragment, null, groupLabel && hasVisibleFields && /*#__PURE__*/React.createElement(Column, {
      width: 12
    }, /*#__PURE__*/React.createElement(Heading, null, groupLabel)), map(group, function (_ref2) {
      var key = _ref2.key,
          fieldProps = _ref2.fieldProps,
          _ref2$field = _ref2.field,
          description = _ref2$field.description,
          column = _ref2$field.column,
          Field = _ref2.Field;
      return (fieldProps === null || fieldProps === void 0 ? void 0 : fieldProps.hidden) ? /*#__PURE__*/React.createElement("span", {
        key: key,
        style: {
          display: 'none'
        }
      }, /*#__PURE__*/React.createElement(Field, fieldProps)) : /*#__PURE__*/React.createElement(Column, {
        key: key,
        width: column * 12
      }, /*#__PURE__*/React.createElement(Field, fieldProps), /*#__PURE__*/React.createElement(Description, null, description));
    }));
  }));
}